import type { SvgInventoryByDate } from 'widget/events/InteractiveFloorplan/types'

export const SET_SVG_INVENTORY = 'SET_SVG_INVENTORY'
export const HANDLE_CLICK = 'HANDLE_CLICK'
export const HANDLE_HOVER = 'HANDLE_HOVER'
export const SET_INTERACTIVE_FLOORPLAN_DIMENSIONS = 'SET_INTERACTIVE_FLOORPLAN_DIMENSIONS'
export const IS_INTERACTIVE_FLOORPLAN_OPEN = 'IS_INTERACTIVE_FLOORPLAN_OPEN'

export const setSvgInventory = (svgInventory: SvgInventoryByDate) => ({
  type: SET_SVG_INVENTORY,
  svgInventory,
})

export interface HandleClickArgs {
  inventoryName: string
  selectedDate: string
}
export const handleClick = (handleClickArgs: HandleClickArgs) => ({ type: HANDLE_CLICK, handleClickArgs })

export interface HandleHoverArgs {
  inventoryName: string
  hover: boolean
  selectedDate: string
}
export const handleHover = (handleHoverArgs: HandleHoverArgs) => ({ type: HANDLE_HOVER, handleHoverArgs })

export interface SetFloorplanDimensionsArgs {
  height: number
  width: number
}
export const setFloorplanDimensions = ({ height, width }: SetFloorplanDimensionsArgs) => ({
  type: SET_INTERACTIVE_FLOORPLAN_DIMENSIONS,
  height,
  width,
})

export const setIsFloorplanOpen = (isOpen: boolean) => ({ type: IS_INTERACTIVE_FLOORPLAN_OPEN, isOpen })
